module.exports = `:root {
  --primitiveColorNeutral210: #323232;
  --primitiveColorNeutral430: #666666;
  --primitiveColorNeutral870: #dadada;
  --primitiveColorNeutral960: #f4f5f6;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorPrimaryGradientA490: #e40000;
  --primitiveColorPrimaryGradientB450: #d20000;
  --primitiveColorPrimarySolid490: #e40000;
  --primitiveColorPrimaryHover370: #ae0000;
  --primitiveColorPrimaryDark280: #870000;
  --primitiveColorSecondaryInfoBlue840: #8de2e0;
  --primitiveColorSecondaryInfoBlue930: #bff5f3;
  --primitiveColorSecondaryInfoBlue970: #e9f9f9;
  --primitiveColorSecondaryBayBlue620: #00a6b4;
  --primitiveColorAlertError640: #f4750c;
  --primitiveColorAlertError940: #fcebcd;
  --primitiveColorAlertSuccess620: #4baa3e;
  --primitiveColorAlertSuccess930: #dff0d8;
  --primitiveColorTextPrimary210: #323232;
  --primitiveColorTextPrimary1000: #fefefe;
  --primitiveColorTextSecondary430: #666666;
  --primitiveColorTextSecondary850: #d4d4d4;
  --primitiveColorStatusBronze490: #e40000;
  --primitiveColorStatusSilver700: #aaaaaa;
  --primitiveColorStatusGold690: #baa67b;
  --primitiveColorStatusPlatinum210: #323232;
  --primitiveColorStatusPlatinumOne930: #ebebeb;
  --primitiveColorStatusChairmansLounge110: #1e1e1e;
  --primitiveTypographyFontFamily: Ciutadella, sans-serif;
  --primitiveTypographyTypescale1: 3.25rem;
  --primitiveTypographyTypescale2: 2.25rem;
  --primitiveTypographyTypescale3: 1.75rem;
  --primitiveTypographyTypescale4: 1.5rem;
  --primitiveTypographyTypescale5: 1.125rem;
  --primitiveTypographyTypescale6: 1rem;
  --primitiveTypographyTypescale7: 0.75rem;
  --primitiveTypographyTypescaleCopySmall: 0.875rem;
  --primitiveTypographyTypescaleCopyLarge: 1.25rem;
}
`;